import { useEffect, useRef, useState } from "react";
import { BarLoader } from "react-spinners";

interface LoadingScreenProps {
  isVisible: boolean;
  onFadeOutComplete?: () => void;
}

const FADE_DURATION = 800; // ms

export function LoadingScreen({
  isVisible,
  onFadeOutComplete,
}: LoadingScreenProps) {
  // Track if we should show the component at all
  const [shouldRender, setShouldRender] = useState(true);
  // Track the previous visibility to detect transitions
  const wasVisible = useRef(true);

  useEffect(() => {
    // Detect transition from visible to hidden
    if (wasVisible.current && !isVisible) {
      // Start fade-out, then remove from DOM after animation
      const timer = setTimeout(() => {
        setShouldRender(false);
        onFadeOutComplete?.();
      }, FADE_DURATION);

      return () => clearTimeout(timer);
    }

    // Update ref for next render
    wasVisible.current = isVisible;
  }, [isVisible, onFadeOutComplete]);

  // Don't render if we've completed the fade out
  if (!shouldRender) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#0a0812",
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
        transition: `opacity ${FADE_DURATION}ms ease-out`,
        zIndex: 1000,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 24,
        }}
      >
        <BarLoader
          color="#6080ff"
          width={200}
          height={4}
          speedMultiplier={0.8}
        />
        <p
          style={{
            color: "rgba(255, 255, 255, 0.5)",
            fontSize: 14,
            fontFamily: "system-ui, sans-serif",
            letterSpacing: "0.1em",
            margin: 0,
          }}
        >
          LOADING
        </p>
      </div>
    </div>
  );
}
